import { defineMessages } from "@/i18n";
import en from "./en";

export const framesCodeMessages = defineMessages("frames-code", en);
